import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const { FiX, FiCopy, FiTrash2, FiAlertTriangle } = FiIcons;
import SafeIcon from '../common/SafeIcon';

export default function DuplicateManagerModal({ groups, usageCounts, onClose, onKeepBest }) {
  return (
    <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} className="fixed inset-0 z-[185] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
      <motion.div initial={{scale:.96,opacity:0}} animate={{scale:1,opacity:1}} exit={{scale:.96,opacity:0}} className="flex max-h-[85vh] w-full max-w-3xl flex-col overflow-hidden rounded-3xl border border-gray-700 bg-gray-900 shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-800 p-6">
          <div className="flex items-center gap-3">
            <div className="rounded-xl bg-amber-500/10 p-2 text-amber-400"><SafeIcon icon={FiCopy} /></div>
            <div>
              <h2 className="text-xl font-bold text-white">Duplicate Manager</h2>
              <p className="text-xs text-gray-500">Exact-content duplicates only. No fuzzy deletion is performed.</p>
            </div>
          </div>
          <button onClick={onClose} className="rounded-full p-2 text-gray-500 hover:bg-gray-800 hover:text-white"><SafeIcon icon={FiX} /></button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          {groups.length === 0 ? (
            <div className="py-16 text-center">
              <SafeIcon icon={FiAlertTriangle} className="mx-auto mb-3 text-3xl text-emerald-400" />
              <div className="font-bold text-white">No exact duplicates found</div>
              <div className="mt-1 text-sm text-gray-500">Your active library is clean.</div>
            </div>
          ) : (
            <div className="space-y-4">
              {groups.map((group, index) => {
                const best = [...group].sort((a,b) =>
                  Math.max(Number(usageCounts[b.id] || 0), Number(b.usageCount || 0)) - Math.max(Number(usageCounts[a.id] || 0), Number(a.usageCount || 0)) ||
                  Number(b.updatedAt || 0) - Number(a.updatedAt || 0)
                )[0];
                return (
                  <div key={best.id + index} className="rounded-2xl border border-gray-800 bg-gray-950/50 p-4">
                    <div className="mb-3 flex items-center justify-between gap-3">
                      <div>
                        <div className="text-sm font-bold text-white">{group.length} identical snippets</div>
                        <div className="text-[10px] text-gray-500">Recommended keeper: {best.title || 'Untitled Snippet'}</div>
                      </div>
                      <button onClick={() => onKeepBest(group, best.id)} className="flex items-center gap-2 rounded-xl bg-red-500/10 px-3 py-2 text-xs font-bold text-red-300 hover:bg-red-500/20">
                        <SafeIcon icon={FiTrash2} /> Keep best, remove others
                      </button>
                    </div>
                    <div className="space-y-2">
                      {group.map(s => (
                        <div key={s.id} className="flex items-center justify-between rounded-xl border border-gray-800 px-3 py-2 text-xs">
                          <span className="truncate text-gray-300">{s.title || 'Untitled Snippet'}</span>
                          <span className="ml-3 shrink-0 text-gray-500">{Math.max(Number(usageCounts[s.id] || 0), Number(s.usageCount || 0))} uses</span>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </motion.div>
    </motion.div>
  );
}